export const RESERVATION_FEE = 5
export const PUBLISH_FIXED_FEE = 10
export const PUBLISH_SEAT_FEE = 5

export const DEV_MODE_FEE = 0.01
